export enum IconName {
  EMAIL = 'email',
  REQ_YES = 'req-yes',
  REQ_NO = 'req-no',
  REQ_FORM = 'req-form',
}
